import React, { useContext } from "react";
import TopHeader from "../Components/TopHeader";
import Prince from "../Components/Prince";
import { useState, useEffect, useRef } from "react";

import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";

import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { BsPersonLinesFill } from "react-icons/bs";
import "./Support.css";
import pdfLogo from "../../src/assets/img/pdfLogo.png";
import excelLogo from "../../src/assets/img/pngegg.png";
import { FaEye } from "react-icons/fa6";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";

import Editor from "./Editor";
import styles from "./Support.module.css";
import EmailPopUp from "./EmailPopUp";
import { DataContext } from "../context/DataContext";
import makeAnimated from "react-select/animated";
import ReactSelect from "react-select";

const apiUrl = process.env.REACT_APP_URL;

const SOCKET_URL = `${apiUrl}`;

export const socket = io(SOCKET_URL, {
  query: { userId: localStorage.getItem("id") },
});

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f0f0f0" : "#fff", // Background color of the control
    borderColor: state.isFocused ? "#2684FF" : "#ccc", // Border color when focused or not
    boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : null, // Box shadow when focused
    "&:hover": {
      borderColor: "#2684FF", // Border color on hover
    },
    padding: "0px",
    // Padding inside the control
  }),
  menu: (provided) => ({
    ...provided,
    width: "100%",
    backgroundColor: "#fff", // Background color of the dropdown menu
    // Rounded corners for the dropdown menu
    zIndex: 999, // Ensure it appears above other elements
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#2684FF"
      : state.isFocused
      ? "#f0f0f0"
      : "#fff", // Background color for selected and focused options
    color: state.isSelected ? "#fff" : "#333", // Text color
    padding: "5px", // Padding inside each option
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333", // Color of the selected value
    fontWeight: "bold", // Bold text for selected value
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#999", // Color of the placeholder text
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#2684FF" : "#ccc", // Color of the dropdown indicator (arrow)
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#2684FF" : "#ccc", // Color of the clear indicator (X)
  }),
};

function Support(apiData) {
  const caseId = useParams();
  const dropdownRef = useRef(null);
  const editorComponentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const employeeData = useContext(DataContext);
  const Token = localStorage.getItem("_ux98c_v1");
  //const Token = localStorage.getItem("_ux98c_v1");
  const [subject, setSubject] = useState("");
  const [openEmail, setOpenEmail] = React.useState(false);
  const [itemDataPopUp, setItemDataPopUp] = useState("");
  const [to, setTo] = useState("");
  const [cc, setCc] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [emailFile, setEmailFile] = useState([]);
  const [modelOpenAwb, setModalOpenAwb] = useState(false);
  const [modelOpenOrderId, setModalOpenOrderId] = useState(false);
  const [modelOPenAssign, setModalOpenAssign] = useState(false);
  const [employeeDepartment, setEmployeeDepartment] = useState([]);
  const [department, setDepartment] = useState([]);
  const [selectedItems, setSelectedItems] = useState("");
  const [selectDepartment, setSelectDepartment] = useState("");
  const [assignedEmployeeId, setAssignedEmployeeId] = useState("");
  const [applyFilter, setApplyFilter] = useState(false);
  const departmentOptions = department.map((dept) => ({
    label: dept.name,
    value: dept.id,
  }));
  const employeeOptions = employeeDepartment.map((dept) => ({
    label: dept.name,
    value: dept.id,
  }));

  const animatedComponents = makeAnimated();

  const boxStyle = {
    // width: "693px",
    height: "100px",
    padding: "2px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
    backgroundColor: "#fff",
    borderRadius: "2px",
    overflowY: "auto",
  };

  const handleCloseMailPopUp = () => {
    setOpenEmail(false);
  };
  const handleOpenMailPopUp = () => {
    setOpenEmail(true);
  };
  //console.log(selectedItems);
  const handleEmployeeAssign = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${apiUrl}/caseM/assignEmployee?caseId=${caseId.caseId}&empIds=${selectedItems}
        `,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        // setSuccessMessage(`Case ${assignedEmployeeId} assigned successfully.`);
        toast.success(data.message);

        setModalOpenAssign(false);
        setSelectDepartment([]);
        setSelectedItems([]);

        setTimeout(() => {
          //window.location.reload();
          setApplyFilter(!applyFilter);
        }, 2000);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setAssignedEmployeeId(null);
      setSelectedItems([]);
    }
  };

  useEffect(() => {
    // Fetch countries and populate the countryOptions
    fetch(`${apiUrl}/employee/allEmpDesig`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data && Array.isArray(data.data)) {
          // setOptions(data.data);
        } else {
          console.error(
            "API response is not in the expected format for countries."
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching country data:", error);
      });
  }, []);

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/7`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          // setLeadSourceOptions(data.data);
          setDepartment(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching gender options:", error);
      });
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/employee/allEmpDesig?department=${selectDepartment}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data && Array.isArray(data.data)) {
          setEmployeeDepartment(data.data);
        } else {
          console.error(
            "API response is not in the expected format for countries."
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching country data:", error);
      });
  }, [selectDepartment]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleEmailFile = async (event) => {
    const file = event.target.files[0];

    setEmailFile(file);
  };

  const sendEmail = async () => {
    const editorContent = editorComponentRef.current?.getContent();
    console.log(editorContent);
    if (!to || !subject || !editorContent) {
      toast.error("Please fill out all required fields.");
      return;
    }

    const formData = new FormData();
    formData.append("receiverEmail", to);
    formData.append("ccEmail", cc);
    formData.append("subject", subject);
    // formData.append("message", content);
    formData.append("message", editorContent);

    if (emailFile) {
      formData.append("uploadedFile", emailFile); // Append the file to FormData
    }

    try {
      const response = await fetch(
        `${apiUrl}/caseM/sendEmail?caseId=${caseId.caseId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Token}`,
            // Do not set 'Content-Type' to 'application/json' when using FormData
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSubject("");
        setCc("");
        // setContent("");
        editorComponentRef.current?.clearContent();

        toast.success("Email sent successfully!");
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        toast.error(data.message || "Failed to send email.");
      }
    } catch (error) {
      toast.error("An error occurred while sending the email.");
      console.error("Error:", error);
    }
  };

  const [emailData, setEmailData] = useState();
  const [awbList, setAwbList] = useState([]);
  const [orderIdList, setOrderIdList] = useState([]);
  const [datestamp, setDatestamp] = useState("");
  const [isNewUser, setIsNewUser] = useState(true);
  const [attachment, setAttachment] = useState("");
  const [attachment1, setAttachment1] = useState("");
  const [showEmojiPicker1, setShowEmojiPicker1] = useState(false);
  const [triggerFetch, setTriggerFetch] = useState(false);
  const [message1, setMessage1] = useState("");
  const [messages1, setMessages1] = useState([]);
  const [caseSubType1, setCaseSubType] = useState([]);
  const [caseList, setCaseList] = useState([]);
  const [userType, setUserType] = useState([]);
  const [doneUpload, setDoneUpload] = useState(false);

  const [employee, setEmployee] = useState("");

  const fileInputRef1 = useRef(null);
  const [employeeList, setEmployeeList] = useState({});
  const [arrayBuffer, setArrayBuffer] = useState("");
  const apiUrl = process.env.REACT_APP_URL;

  const chatWindowRef = useRef(null);
  const chatWindowRef1 = useRef(null);
  const readFileAsArrayBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };

  useEffect(() => {
    async function getEmp() {
      const url = `${apiUrl}/employee/employee`;

      const Token = localStorage.getItem("_ux98c_v1");
      // console.log("Token " + Token);

      let response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      response = await response.json();

      if (response.status === "success") {
        setEmployee(response.data);
      } else if (response.status === "error") {
      }
    }
    getEmp();
  }, []);

  useEffect(() => {
    const Token = localStorage.getItem("_ux98c_v1");

    fetch(`${apiUrl}/caseMaster/getCaseType`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          if (Array.isArray(data.data)) {
            setCaseList(data.data);
          } else {
            console.error("API response does not contain users array:", data);
          }
        } else {
          console.error("API request was not successful:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    const Token = localStorage.getItem("_ux98c_v1");

    fetch(`${apiUrl}/caseM/getCaseEmail?caseId=${caseId.caseId}`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          if (Array.isArray(data.data)) {
            setEmailData(data.data);
          } else {
            console.error("API response does not contain users array:", data);
          }
        } else {
          console.error("API request was not successful:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const getCurrentDate = () => {
    const today = new Date();
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return today.toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    const currentDate = getCurrentDate();
    setDatestamp(currentDate);
  }, []);

  const capitalizeFirstLetterOfEachWord = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return "Today";
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    } else {
      const options = {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      };
      return date.toLocaleDateString("en-US", options);
    }
  };

  useEffect(() => {
    if (chatWindowRef1.current) {
      chatWindowRef1.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages1, attachment1]);

  useEffect(() => {
    const Token = localStorage.getItem("_ux98c_v1");

    fetch(`${apiUrl}/caseMaster/getAllCaseSubType`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          if (Array.isArray(data.data)) {
            setCaseSubType(data.data);
          } else {
            console.error("API response does not contain users array:", data);
          }
        } else {
          console.error("API request was not successful:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const handleCheckboxChangeAssign = (option) => {
    const selectedLabels = option.map((options) => options.value);
    setSelectedItems(selectedLabels);
  };

  const handleAwbNoList = () => {
    fetch(`${apiUrl}/caseM/awbList?caseId=${caseId.caseId}`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setAwbList(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching AWB list:", error);
      });
  };

  const handleCloseModalAwb = () => {
    setModalOpenAwb(false);
  };
  const handleCloseModalOrderId = () => {
    setModalOpenOrderId(false);
  };

  const handleOrderIdList = () => {
    // setModalOpenAwb(true);

    fetch(`${apiUrl}/caseM/ordeIdList?caseId=${caseId.caseId}`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setOrderIdList(data.data);
        } else {
          console.error("API response does not contain an array:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching AWB list:", error);
      });
  };

  const handleFileChange1 = async (event) => {
    const file = event.target.files[0];

    if (file) {
      try {
        const arrayBuffer = await readFileAsArrayBuffer(file);
        setArrayBuffer(arrayBuffer);

        setAttachment1(file);
      } catch (error) {
        console.error("Error reading file:", error);
      }
    }
  };

  const [allCaseList, setAllCaseList] = useState([]);

  useEffect(() => {
    setFilteredData(allCaseList);
  }, [allCaseList]);

  useEffect(() => {
    async function getEmp() {
      const url = `${apiUrl}/caseM/getCase?caseId=${caseId.caseId}`;

      const Token = localStorage.getItem("_ux98c_v1");

      let response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      response = await response.json();

      setEmployeeList(response.data);
      setAllCaseList(response.data);
      setTo(response.data.customer?.emailId);
    }
    getEmp();
  }, [applyFilter]);

  useEffect(() => {
    if (!caseId?.caseId) return;

    if (!socket.connected) {
      socket.connect();
      socket.once("connect", () => {
        socket.emit("joinRoom", caseId.caseId);
      });
    } else {
      socket.emit("joinRoom", caseId.caseId);
    }
  }, [caseId?.caseId]);

  useEffect(() => {
    if (!caseId?.caseId) return;

    const handleChatHistory = (messages) => {
      setMessages1(messages);
    };

    const handleMessageReceived = (message) => {
      setMessages1((prevMessages) => [...prevMessages, message]);
    };

    socket.on("chatHistory", handleChatHistory);
    socket.on("messageReceived", handleMessageReceived);

    // 🧹 Cleanup listeners on unmount or caseId change
    return () => {
      socket.off("chatHistory", handleChatHistory);
      socket.off("messageReceived", handleMessageReceived);
    };
  }, [caseId?.caseId]);

  useEffect(() => {
    setIsNewUser(true);
  }, []);

  const sendMessage1 = () => {
    setShowEmojiPicker1(false);
    setIsNewUser(false);

    // console.log(attachment1);
    if (attachment1 && attachment1.size > 50 * 1024 * 1024) {
      toast.error("File size is too large. Please select a smaller file.");
      return;
    }
    const formData = new FormData();
    formData.append("caseId", caseId.caseId);
    formData.append("Token", Token);
    if (message1 || attachment1) {
      formData.append("message", message1);
      if (attachment1 && attachment1.size <= 1 * 1024 * 1024) {
        formData.append("attachment", attachment1);
      }

      if (attachment1) {
        switch (attachment1.type) {
          case "application/x-zip-compressed":
          case "application/zip":
          case "application/x-7z-compressed":
          case "image/jpeg":
          case "image/jpg":
          case "image/png":
          case "image/svg+xml":
          case "application/pdf":
          case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          case "application/vnd.ms-excel":
          case "application/msword":
          case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          case "text/plain":
          case "text/csv":
          case "application/json":
          case "video/mp4":
          case "audio/mpeg":
          case "application/vnd.android.package-archive":
          case "application/vnd.ms-powerpoint":
          case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
            formData.append("mimeType", attachment1.type);
            break;
          default:
            toast.error("File type not supported");
            return;
        }
      }
    }
    const formDataObject = {};
    formData.forEach((value, key) => {
      formDataObject[key] = value;
    });

    socket.emit("messageReceived", formDataObject);

    if (attachment1 && attachment1.size >= 1 * 1024 * 1024) {
      uploadedAttachment(attachment1);
    }

    setMessage1("");
    // console.log(formDataObject);
    setAttachment1(null);
  };

  const uploadedAttachment = async (file) => {
    setLoading(true);
    const formData = new FormData();
    // document.body.style.overflow = "hidden";
    formData.append("attachment", file);

    try {
      const response = await fetch(
        `${apiUrl}/caseM/postChat?customerId=${localStorage.getItem(
          "id"
        )}&caseId=${caseId.caseId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Token}`,
            // ❌ DO NOT SET 'Content-Type' for FormData!
            // The browser will automatically set it to `multipart/form-data` with the correct boundary
          },
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok) {
        console.log("Upload success:", result);
        //setAttachment1(null);
        // document.body.style.overflow = "auto";
        setDoneUpload(!doneUpload);

        setLoading(false);
        // sendMessage1();
      } else {
        console.error("Upload failed:", result);
      }
    } catch (error) {
      console.error("Error while uploading:", error);
    }
  };

  useEffect(() => {
    sendMessage1();
  }, [caseId.caseId, doneUpload]);

  const isSameDay = (d1, d2) => {
    const date1 = new Date(d1);
    const date2 = new Date(d2);
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };
  function convertTimestamp(timestampString) {
    const [datePart, timePart] = timestampString.split(", ");
    const [day, monthStr, year] = datePart.split("/");
    const month = parseInt(monthStr) - 1;
    const [time, meridianPart] = timePart.split(" ");
    const [hourStr, minute, second] = time.split(":");
    let hourNum = parseInt(hourStr);

    if (meridianPart === "pm" && hourNum !== 12) {
      hourNum += 12;
    }

    if (meridianPart === "am" && hourNum === 12) {
      hourNum = 0;
    }
    const timestamp = new Date(year, month, day, hourNum, minute, second);

    const options = {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZoneName: "short",
    };
    return timestamp.toLocaleString("en-US", options);
  }
  const Time = convertTimestamp("24/5/2024, 12:18:53 pm");

  const handleEmojiSelect1 = (emoji) => {
    setMessage1(message1 + emoji.native);
    //console.log(emoji);
  };

  const handleKeyPress1 = (event) => {
    if (event.key === "Enter") {
      sendMessage1();
    }
  };

  const formatTimestamp = (timestamp) => {
    const messageDate = new Date(timestamp);
    const currentDate = new Date();
    const sameDay = messageDate.toDateString() === currentDate.toDateString();
    let formattedTime = messageDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return formattedTime;
  };

  const handleCloseModalAssign = () => {
    setModalOpenAssign(false);
  };

  const handleDepartmentAssign1 = (option) => {
    const selectedLabels = option.map((options) => options.label);
    // console.log("Selected Labels:", selectedLabels);
    setSelectDepartment(selectedLabels);
  };

  const scrollToBottom1 = () => {
    if (chatWindowRef1.current) {
      chatWindowRef1.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    handleAwbNoList();
  }, [caseId]);

  useEffect(() => {
    handleOrderIdList();
  }, [caseId]);

  return (
    <>
      <div>
        <div className="page">
          {/* Main Header*/}
          <TopHeader />
          <Prince />

          <div
            className="main-content  pt-0 "
            // style={{ marginLeft: "0" }}
          >
            <div className="main-container container-fluid">
              <div className="inner-body">
                <div className="page-header">
                  <div>
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Support/NDR ID:<span>{caseId.caseId}</span>
                    </h2>
                    <ol className="breadcrumb">
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Support / All Tickets /<span>{caseId.caseId}</span>
                      </li>
                    </ol>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-3">
                    <div className="card custom-card chat-account">
                      <div className="d-block pt-0">
                        <div className="card-body text-center">
                          <div className="user-lock text-center">
                            <a href="#">
                              <img
                                alt="avatar"
                                className="rounded-10"
                                src={
                                  filteredData?.customer?.employee
                                    ?.profilePic == "" ||
                                  filteredData?.customer === null
                                    ? "https://img.freepik.com/free-psd/3d-rendering-avatar_23-2150833572.jpg?t=st=1715169602~exp=1715173202~hmac=be6698750cd88fb3a0e0ffac84f72621f3d80b6e6529eb05c5a2874539394cdc&w=740"
                                    : `${apiUrl}/uploads/${filteredData?.customer?.employee?.profilePic}`
                                }
                              />
                            </a>
                          </div>
                          <a href="#">
                            <h5 className=" mb-1 mt-3 main-content-label">
                              {filteredData?.customer?.employee?.firstName}{" "}
                              {filteredData?.customer?.employee?.lastName}
                            </h5>
                          </a>
                          <p className="mb-0 mt-1 text-muted">
                            {filteredData?.customer?.employee.userRole}
                          </p>
                          <p className="mb-0 mt-0 text-muted">
                            {userType.companyName}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card custom-card">
                      <div className="card-body py-3">
                        {employeeList?.awbNo?.length === 1 ? (
                          <p className="mb-0 border border-primary">
                            Awb No: <b>{employeeList.awbNo[0]?.awbNo}</b>
                          </p>
                        ) : employeeList?.awbNo?.length === 0 ? null : (
                          <p className="mb-0 border border-primary">
                            Awb No:{" "}
                            <b
                              style={{
                                cursor: "pointer",
                                color: "#032852",
                              }}
                              onClick={() => {
                                handleAwbNoList();
                                setModalOpenAwb(true);
                              }}
                            >
                              Click Here
                            </b>
                          </p>
                        )}
                        {employeeList?.orderId?.length === 1 ? (
                          <p className="mb-0 border border-primary  ">
                            Order Id: <b>{employeeList?.orderId[0]?.orderId}</b>
                          </p>
                        ) : employeeList?.orderId?.length === 0 ? null : (
                          <p className="mb-0 border border-primary">
                            Order Id:{" "}
                            <b
                              style={{
                                cursor: "pointer",
                                color: "#032852",
                              }}
                              onClick={() => {
                                handleOrderIdList();
                                setModalOpenOrderId(true);
                              }}
                            >
                              Click Here
                            </b>
                          </p>
                        )}

                        {employeeList?.selectReason ? (
                          <p className="mb-0 border border-primary">
                            Select Reason : <b>{employeeList.selectReason}</b>
                          </p>
                        ) : null}
                        {employeeList.beneficiaryName ? (
                          <p className="mb-0 border border-primary">
                            Beneficiary Account Name :{" "}
                            <b>{employeeList.beneficiaryName}</b>
                          </p>
                        ) : null}
                        {employeeList.beneficiaryAccountNumber ? (
                          <p className="mb-0 border border-primary">
                            Beneficiary Account Number :{" "}
                            <b>{employeeList.beneficiaryAccountNumber}</b>
                          </p>
                        ) : null}
                        {employeeList.beneficiaryIfscCode ? (
                          <p className="mb-0 border border-primary">
                            Beneficiary IFSC Code :{" "}
                            <b>{employeeList.beneficiaryIfscCode}</b>
                          </p>
                        ) : null}
                        {employeeList.uploadImage ? (
                          <p className="mb-0 border border-primary">
                            Upload Image:{" "}
                            <b>
                              <a
                                href={employeeList.uploadImage}
                                target="_blank"
                              >
                                Click Here
                              </a>
                            </b>
                          </p>
                        ) : null}
                        {employeeList.otherIssueDescribe ? (
                          <div className="mb-0 border border-primary">
                            Other Issue Describe :{" "}
                            <div style={boxStyle}>
                              <b>{employeeList.otherIssueDescribe}</b>
                            </div>
                          </div>
                        ) : null}
                        {employeeList.discriptionIssue ? (
                          <div className="mb-0 border border-primary">
                            Discription Issue :{" "}
                            <div style={boxStyle}>
                              {" "}
                              <b>{employeeList.discriptionIssue}</b>
                            </div>
                          </div>
                        ) : null}
                        {employeeList.selectIssue ? (
                          <p className="mb-0 border border-primary">
                            Select Issue : <b>{employeeList.selectIssue}</b>
                          </p>
                        ) : null}
                        {employeeList.transactionID ? (
                          <p className="mb-0 border border-primary">
                            Transaction ID : <b>{employeeList.transactionID}</b>
                          </p>
                        ) : null}
                        {employeeList.companyType ? (
                          <p className="mb-0 border border-primary">
                            Company Type: <b>{employeeList.companyType}</b>
                          </p>
                        ) : null}
                        {employeeList.relatedIssue ? (
                          <p className="mb-0 border border-primary">
                            Related Issue : <b>{employeeList.relatedIssue}</b>
                          </p>
                        ) : null}
                        {employeeList.selectChannel ? (
                          <p className="mb-0 border border-primary">
                            Select Channel : <b>{employeeList.selectChannel}</b>
                          </p>
                        ) : null}
                        {employeeList.selectOrderType ? (
                          <p className="mb-0 border border-primary">
                            Select Order Type:{" "}
                            <b>{employeeList.selectOrderType}</b>
                          </p>
                        ) : null}
                        {employeeList.timePeriod ? (
                          <p className="mb-0 border border-primary">
                            Time Period : <b>{employeeList.timePeriod}</b>
                          </p>
                        ) : null}
                        {employeeList.receivedIncorrectInvoice ? (
                          <p className="mb-0 border border-primary">
                            Received Incorrect Invoice :{" "}
                            <b>{employeeList.receivedIncorrectInvoice}</b>
                          </p>
                        ) : null}
                        {employeeList.incorrectMissingCompanyName ? (
                          <p className="mb-0 border border-primary">
                            Incorrect Missing Company Name :{" "}
                            <b>{employeeList.incorrectMissingCompanyName}</b>
                          </p>
                        ) : null}
                        {employeeList.incorrectMissingCompanyAddress ? (
                          <p className="mb-0 border border-primary">
                            Incorrect Missing Company Address :{" "}
                            <b>{employeeList.incorrectMissingCompanyAddress}</b>
                          </p>
                        ) : null}
                        {employeeList.incorrectMissingGSTIN ? (
                          <p className="mb-0 border border-primary">
                            Incorrect Missing GSTIN :{" "}
                            <b>{employeeList.incorrectMissingGSTIN}</b>
                          </p>
                        ) : null}
                        {employeeList.others ? (
                          <p className="mb-0 border border-primary">
                            Other : <b>{employeeList.others}</b>
                          </p>
                        ) : null}
                        {employeeList.invoiceNumber ? (
                          <p className="mb-0 border border-primary">
                            Invoice Number : <b>{employeeList.invoiceNumber}</b>
                          </p>
                        ) : null}
                        {employeeList.issuePlatform ? (
                          <p className="mb-0 border border-primary">
                            Platform Issue : <b>{employeeList.issuePlatform}</b>
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-3">
                    <div className="card custom-card chat-account">
                      <div className=" d-block pt-0">
                        <div className="card-body text-center">
                          <div className="user-lock text-center">
                            <a href="#">
                              <img
                                alt="avatar"
                                className="rounded-10"
                                src="https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg?t=st=1715174620~exp=1715178220~hmac=dbed534076f1c7fc3f145a9fa7624fcd843b5e911c75225143770d6a8fb67d4a&w=740"
                              />
                            </a>
                          </div>
                          <a href="#">
                            <h5 className=" mb-1 mt-3 main-content-label">
                              {" "}
                              {filteredData?.customer?.primaryContactName}
                            </h5>
                          </a>

                          <p className="mb-0 mt-0 text-muted">
                            {filteredData?.customer?.mobileNumber}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row row-sm mt-3">
                  {filteredData?.showEmail ? (
                    <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12">
                      <div className="card custom-card">
                        <div className="pt-0">
                          <div className={styles.App}>
                            <input
                              type="email"
                              placeholder="To."
                              value={to}
                              onChange={(e) => setTo(e.target.value)}
                              className={styles.input}
                              style={{ color: "#808080" }}
                            />
                            <input
                              type="email"
                              placeholder="Cc."
                              value={cc}
                              onChange={(e) => setCc(e.target.value)}
                              className={styles.input}
                              style={{ color: "#808080" }}
                            />
                            <input
                              type="text"
                              placeholder="Subject"
                              value={subject}
                              onChange={(e) => setSubject(e.target.value)}
                              className={styles.input}
                              style={{ color: "#808080" }}
                            />

                            <Editor ref={editorComponentRef} />
                            <div>
                              <div class="input-group mt-3">
                                <input
                                  type="file"
                                  class="form-control"
                                  id="inputGroupFile02"
                                  onChange={(event) => handleEmailFile(event)}
                                />
                              </div>
                              <button
                                onClick={sendEmail}
                                className="btn btn-primary ml-3 mt-3"
                              >
                                Send Email
                              </button>
                            </div>
                            <div
                              className="list-group-container"
                              style={{
                                height: "150px",
                                overflowY: "auto",
                                marginTop: "10px",
                              }}
                            >
                              <div
                                className="list-group mt-2 "
                                style={{ padding: "10px" }}
                              >
                                {emailData?.map((item, index) => (
                                  <a
                                    className="list-group-item list-group-item-action flex-column align-items-start"
                                    key={index}
                                    style={{
                                      border: "1px solid #B2BEB5",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        position: "absolute",
                                        left: "-10px",
                                        bottom: "40px",
                                        backgroundColor: "#219C90",
                                        color: "#f4f4f4",
                                        fontSize: "9px",
                                        borderRadius: "5px",
                                        padding: "3px",
                                      }}
                                    >
                                      {item.isCustomer === true
                                        ? "Customer"
                                        : "KAM"}
                                    </span>
                                    <div
                                      className="d-flex w-100 justify-content-between"
                                      style={{ height: "20px" }}
                                    >
                                      <span
                                        className="d-flex "
                                        style={{ width: "85%" }}
                                      >
                                        <FaEye
                                          className="mr-2"
                                          onClick={() => {
                                            handleOpenMailPopUp();
                                            setItemDataPopUp(item);
                                          }}
                                          style={{
                                            cursor: "pointer",
                                            marginTop: "3px",
                                          }}
                                        />

                                        <span
                                          className="text-truncate mb-0 font-weight-bold"
                                          style={{ width: "90%" }}
                                        >
                                          {`${item.subject}`}
                                        </span>
                                      </span>
                                      <small>
                                        {formatDate(item.createdAt)}
                                      </small>
                                    </div>
                                  </a>
                                ))}
                              </div>
                            </div>
                          </div>

                          <EmailPopUp
                            item={itemDataPopUp}
                            handleClose={handleCloseMailPopUp}
                            open={openEmail}
                          ></EmailPopUp>
                          <div className="main-content-body main-content-body-chat"></div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      // className="col-sm-12 col-md-12 col-lg-7 col-xl-5"
                      className="col-xl-5 col-lg-12 col-md-12 col-sm-12"
                      // style={{
                      //   position: "relative",
                      //   left: "10px",
                      //   top: "0px",
                      //   borderRadius: "10px",
                      // }}
                    >
                      <div className="card">
                        <h5 className="card-header bg-black-1">
                          Assigned Employee List
                        </h5>
                        <List
                          sx={{
                            width: "100%",
                            maxWidth: 580,
                            bgcolor: "background.paper",
                          }}
                        >
                          {employeeList.EmployeeCasesM?.map((item, index) => (
                            <div key={index}>
                              <ListItem alignItems="flex-start">
                                <ListItemAvatar>
                                  <Avatar
                                    alt="Remy Sharp"
                                    src={item?.employee?.profilePic}
                                  />
                                </ListItemAvatar>
                                <ListItemText
                                  primary={capitalizeFirstLetterOfEachWord(
                                    `${item.employee?.firstName}  ${item.employee?.lastName}`
                                  )}
                                  secondary={
                                    <React.Fragment>
                                      <Typography
                                        sx={{ display: "inline" }}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                      ></Typography>
                                      {item.employee?.email}
                                    </React.Fragment>
                                  }
                                />
                              </ListItem>
                              <Divider variant="inset" component="li" />
                            </div>
                          ))}
                        </List>
                      </div>
                    </div>
                  )}

                  <div
                    // className={
                    //   filteredData?.showEmail
                    //     ? "col-sm-12 col-md-12 col-lg-7 col-xl-5"
                    //     : "col-sm-6 col-md-6"
                    // }
                    // style={
                    //   filteredData?.showEmail
                    //     ? {}
                    //     : { position: "relative", left: "-242px" }
                    // }
                    className={`col-xl-${
                      filteredData?.showEmail ? "5" : "7"
                    } col-lg-12 col-md-12 col-sm-12`}
                  >
                    <div className="card custom-card">
                      <div className=" pt-0">
                        <div className="main-content-body main-content-body-chat">
                          <div
                            className="main-chat-header pt-3"
                            style={{
                              background: "#f4f6ff",
                              borderTopLeftRadius: 10,
                              borderTopRightRadius: 10,
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className="main-chat-msg-name">
                              <h6>Internal Notes &amp; Chat</h6>
                            </div>

                            <div>
                              <span>
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => setModalOpenAssign(true)}
                                >
                                  + Employee
                                </button>
                              </span>
                              <Button
                                aria-controls={
                                  open ? "demo-positioned-menu" : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                onClick={handleClick}
                                style={{ fontSize: "12px", color: "#808080" }}
                              >
                                Employees List
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    color: "#41B06E",
                                  }}
                                >
                                  <BsPersonLinesFill size={20} />
                                </span>
                              </Button>
                              <Menu
                                id="demo-positioned-menu"
                                aria-labelledby="demo-positioned-button"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                              >
                                {employeeList.EmployeeCasesM?.map(
                                  (item, index) => (
                                    <MenuItem key={index}>
                                      {capitalizeFirstLetterOfEachWord(
                                        item.employee?.firstName
                                      )}{" "}
                                      {capitalizeFirstLetterOfEachWord(
                                        item.employee?.lastName
                                      )}
                                    </MenuItem>
                                  )
                                )}
                              </Menu>
                            </div>
                          </div>

                          <div
                            className={`modal ${
                              modelOPenAssign ? "show" : ""
                            } bg-black-7`}
                            style={{
                              display: modelOPenAssign ? "block" : "none",
                            }}
                            tabIndex="-1"
                            role="dialog"
                          >
                            <div
                              className="modal-dialog modal-dialog-centered modal-sm"
                              role="document"
                            >
                              <div className="modal-content rounded-3">
                                <div className="modal-header">
                                  <h5 className="modal-title">Case Assign</h5>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={handleCloseModalAssign}
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div
                                  className="modal-body"
                                  // style={{ width: "100%" }}
                                >
                                  <div className="row row-sm-1">
                                    <div className="mb-3">
                                      <label className="form-label">
                                        Department
                                      </label>
                                      <ReactSelect
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        onChange={(option) => {
                                          handleDepartmentAssign1(option);
                                        }}
                                        styles={customStyles}
                                        isMulti
                                        options={departmentOptions}
                                      />
                                    </div>
                                    <div
                                      className="col-sm-4 form-group "
                                      style={{ minWidth: "100%" }}
                                      ref={dropdownRef}
                                    >
                                      <label className="form-label">
                                        Employee :{" "}
                                      </label>

                                      <ReactSelect
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        // defaultValue={[
                                        //   colourOptions[4],
                                        //   colourOptions[5],
                                        // ]}
                                        onChange={(option) => {
                                          handleCheckboxChangeAssign(option);
                                        }}
                                        styles={customStyles}
                                        isMulti
                                        options={employeeOptions}
                                      />
                                    </div>
                                    <div className="col-lg-12">
                                      <button
                                        className="btn ripple btn-primary"
                                        type="button"
                                        onClick={(e) => handleEmployeeAssign(e)}
                                      >
                                        Assign
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="main-chat-body"
                            id="ChatBody"
                            style={{
                              overflowY: "scroll",
                              height: "564px",
                              padding: "10px",
                            }}
                          >
                            {messages1.length > 0 && (
                              <label className="main-chat-time">
                                <span
                                  style={{
                                    fontSize: "8px",
                                    fontFamily: "sans-serif",
                                    color: "#808080",
                                  }}
                                >
                                  {formatDate(messages1[0]?.createdAt)}
                                </span>
                              </label>
                            )}

                            {messages1.map((msg, index) => {
                              const showUsername =
                                index === 0 ||
                                messages1[index - 1]?.employeeId !==
                                  msg?.employeeId;
                              const showDateSeparator =
                                index === 0 ||
                                isSameDay(
                                  messages1[index - 1].createdAt,
                                  msg.createdAt
                                );

                              return (
                                <div
                                  className="content-inner"
                                  key={index}
                                  style={{ padding: "0" }}
                                >
                                  {!showDateSeparator && (
                                    <label className="main-chat-time">
                                      <span
                                        style={{
                                          fontSize: "8px",
                                          fontFamily: "sans-serif",
                                          color: "#808080",
                                        }}
                                      >
                                        {formatDate(msg.createdAt)}
                                      </span>
                                    </label>
                                  )}

                                  <div
                                    className={`media ${
                                      employee?.id !== msg?.employeeId
                                        ? "flex-row-reverse"
                                        : ""
                                    }`}
                                  >
                                    <div
                                      className="media-body"
                                      style={{ marginBottom: 0 }}
                                    >
                                      {msg.message == "" ? null : (
                                        <>
                                          {employee.id !== msg.employeeId &&
                                            showUsername && (
                                              <div style={{ display: "flex" }}>
                                                <p
                                                  style={{
                                                    marginBottom: "2px",
                                                    fontSize: "9px",
                                                    fontWeight: 200,
                                                    fontFamily: "sans-serif",
                                                    color: "#808080",

                                                    marginLeft: "5px",
                                                  }}
                                                >
                                                  {" "}
                                                  {capitalizeFirstLetterOfEachWord(
                                                    msg?.createdBy
                                                  )}
                                                </p>
                                              </div>
                                            )}

                                          <div
                                            className="main-msg-wrapper"
                                            style={{
                                              paddingRight: "50px",
                                              backgroundColor: "#dcf8c6",
                                              borderRadius: "8px",
                                            }}
                                          >
                                            {msg.message}
                                            <span
                                              style={{
                                                position: "absolute",
                                                fontSize: "9px",
                                                top: "25px",
                                                color: "#808080",
                                                right: "6px",
                                              }}
                                            >
                                              {" "}
                                              {formatTimestamp(
                                                convertTimestamp(
                                                  msg.createdAtDate
                                                )
                                              )}
                                            </span>
                                          </div>
                                        </>
                                      )}
                                      <div>
                                        <a href="#">
                                          <i className="icon ion-android-more-horizontal" />
                                        </a>
                                      </div>
                                      {msg.message == ""
                                        ? msg.attachment && (
                                            <div>
                                              {msg?.attachment.endsWith(
                                                ".jpg"
                                              ) ||
                                              msg?.attachment.endsWith(
                                                ".png"
                                              ) ||
                                              msg?.attachment.endsWith(
                                                ".JPG"
                                              ) ||
                                              msg?.attachment.endsWith(
                                                ".PNG"
                                              ) ||
                                              msg?.attachment.endsWith(
                                                ".JPEG"
                                              ) ||
                                              msg?.attachment.endsWith(
                                                ".jpeg"
                                              ) ? (
                                                <>
                                                  {" "}
                                                  <div
                                                    style={{
                                                      position: "relative",
                                                      display: "inline-block",
                                                      marginBottom: "7px",
                                                    }}
                                                  >
                                                    {employee.id !==
                                                      msg.employeeId &&
                                                      showUsername && (
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <p
                                                            style={{
                                                              marginBottom:
                                                                "2px",
                                                              fontSize: "9px",
                                                              fontWeight: 200,
                                                              fontFamily:
                                                                "sans-serif",
                                                              color: "#808080",

                                                              marginLeft: "5px",
                                                            }}
                                                          >
                                                            {" "}
                                                            {capitalizeFirstLetterOfEachWord(
                                                              msg?.createdBy
                                                            )}
                                                          </p>
                                                        </div>
                                                      )}
                                                    <a
                                                      href={`${msg?.attachment}`}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      style={{
                                                        marginBottom: "10px",
                                                        marginTop: "15px",

                                                        color: "#fff",

                                                        borderRadius: "3px",
                                                      }}
                                                      onLoad={scrollToBottom1}
                                                    >
                                                      <img
                                                        src={msg.attachment}
                                                        alt="Attachment"
                                                        style={{
                                                          maxWidth: "200px",
                                                          borderRadius: "8px",
                                                        }}
                                                        // onLoad={scrollToBottom1}
                                                      />
                                                    </a>
                                                    <p
                                                      style={{
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: -7,
                                                        width: "100%",
                                                        marginBottom: 0,
                                                        textAlign: "right",
                                                        fontSize: "9px",

                                                        color: "#fff",
                                                      }}
                                                    >
                                                      {formatTimestamp(
                                                        convertTimestamp(
                                                          msg.createdAtDate
                                                        )
                                                      )}
                                                    </p>
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  <div>
                                                    {employee.id !==
                                                      msg.employeeId &&
                                                      showUsername && (
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <p
                                                            style={{
                                                              marginBottom:
                                                                "2px",
                                                              fontSize: "9px",
                                                              fontWeight: 200,
                                                              fontFamily:
                                                                "sans-serif",
                                                              color: "#808080",

                                                              marginLeft: "5px",
                                                            }}
                                                          >
                                                            {" "}
                                                            {capitalizeFirstLetterOfEachWord(
                                                              msg?.createdBy
                                                            )}
                                                          </p>
                                                        </div>
                                                      )}
                                                    <a
                                                      href={`${msg?.attachment}`}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      style={{
                                                        marginBottom: "10px",
                                                        marginTop: "15px",

                                                        color: "#fff",

                                                        borderRadius: "3px",
                                                      }}
                                                      onLoad={scrollToBottom1}
                                                    >
                                                      <img
                                                        src={
                                                          msg?.attachment.endsWith(
                                                            ".pdf"
                                                          )
                                                            ? pdfLogo
                                                            : excelLogo
                                                        }
                                                        alt="Attachment"
                                                        style={{
                                                          maxWidth: "100px",
                                                        }}
                                                      />
                                                    </a>{" "}
                                                    <p
                                                      style={{
                                                        fontWeight: 200,
                                                        fontFamily:
                                                          "sans-serif",
                                                        color: "#808080",
                                                        position: "relative",
                                                        left: "15px",
                                                        top: 0,
                                                        fontSize: "9px",
                                                      }}
                                                    >
                                                      {formatTimestamp(
                                                        convertTimestamp(
                                                          msg.createdAtDate
                                                        )
                                                      )}
                                                    </p>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          )
                                        : null}
                                    </div>
                                  </div>
                                  <div ref={chatWindowRef1} />
                                </div>
                              );
                            })}
                            {loading && (
                              <div className="loader mx-2">Uploading...</div>
                            )}
                          </div>
                          <div className="main-chat-footer">
                            <nav className="nav">
                              <a
                                className="nav-link"
                                data-bs-toggle="tooltip"
                                // href
                                style={{ cursor: "pointer" }}
                                title="Attach a File"
                                onClick={() => fileInputRef1.current.click()}
                              >
                                <i className="fe fe-paperclip" />
                                <input
                                  type="file"
                                  style={{ display: "none" }}
                                  onChange={handleFileChange1}
                                  ref={fileInputRef1}
                                />
                              </a>

                              <a
                                className="nav-link"
                                data-bs-toggle="tooltip"
                                // href
                                title="Emoji"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  setShowEmojiPicker1(!showEmojiPicker1)
                                }
                              >
                                <i className="far fa-smile" />
                              </a>
                            </nav>
                            <input
                              className="form-control"
                              value={message1}
                              onChange={(e) => setMessage1(e.target.value)}
                              placeholder={
                                attachment1
                                  ? `File selected : ${attachment1.name}`
                                  : "Type your message here..."
                              }
                              onKeyDown={handleKeyPress1}
                              style={{ color: "#000" }}
                            />
                            {message1 !== "" || attachment1 !== null ? (
                              <a
                                className="main-msg-send"
                                onClick={sendMessage1}
                              >
                                <i className="far fa-paper-plane" />
                              </a>
                            ) : null}
                            <div
                              style={{
                                zIndex: 23,
                                position: "absolute",
                                left: "0",
                                bottom: "70px",
                              }}
                            >
                              {showEmojiPicker1 && (
                                <Picker
                                  data={data}
                                  onEmojiSelect={handleEmojiSelect1}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="main-footer text-center">
            <div className="container">
              <div className="row row-sm">
                <div className="col-md-12">
                  <span>
                    Copyright © 2022 <a href="#">Fship</a>. Designed by{" "}
                    <a href="#">Spruko</a> All rights reserved.
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/*End Footer*/}
        </div>

        <div
          className={`modal ${modelOpenAwb ? "show" : ""} bg-black-7`}
          style={{
            display: modelOpenAwb ? "block" : "none",
            overflowY: "auto",
          }}
          tabIndex="-1"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-sm"
            role="document"
          >
            <div className="modal-content rounded-3">
              <div className="modal-header">
                <h5 className="modal-title">AWB Number List</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={handleCloseModalAwb}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div
                className="modal-body"
                style={{ maxHeight: "80vh", overflowY: "auto" }}
              >
                <div className="row">
                  <div className="col form-group">
                    <ul className="list-group">
                      {awbList.map((item, index) => (
                        <li
                          className="list-group-item list-group-item-primary"
                          key={index}
                        >
                          {item.awbNo}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal ${modelOpenOrderId ? "show" : ""} bg-black-7`}
          style={{
            display: modelOpenOrderId ? "block" : "none",
            overflowY: "auto",
          }}
          tabIndex="-1"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-sm"
            role="document"
          >
            <div className="modal-content rounded-3">
              <div className="modal-header">
                <h5 className="modal-title">Order Id List</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={handleCloseModalOrderId}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div
                className="modal-body"
                style={{ maxHeight: "80vh", overflowY: "auto" }}
              >
                <div className="row">
                  <div className="col form-group">
                    <ul className="list-group">
                      {orderIdList.map((item, index) => (
                        <li
                          className="list-group-item list-group-item-primary"
                          key={index}
                        >
                          {item.orderId}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a href="#top" id="back-to-top">
          <i className="fe fe-arrow-up" />
        </a>
      </div>
    </>
  );
}

export default Support;
